import * as t from 'io-ts';
import {
  Breadcrumb,
  CabTypesAvailableForRent,
  Faq,
  RouteInfo
} from '../../../src/pages/runtime-typechecker';

export const ReadMoreData = t.type({
  title: t.string,
  shortDescription: t.string,
  description: t.string
});
export type ReadMoreDataType = t.TypeOf<typeof ReadMoreData>;
export const OutStationOneWayTemplateData = t.type({
  templateName: t.union([t.undefined, t.string]),
  metaTitle: t.string,
  metaDescription: t.string,
  metaKeywords: t.string,
  sampleUrl: t.string,
  analytics: t.string,
  footerData: t.string,
  h1Title: t.string,
  extraInfo: t.string,
  breadcrumb: t.array(Breadcrumb),
  externalJs: t.string,
  faq: t.array(Faq),
  bannerDesktop: t.union([t.undefined, t.string]),
  bannerMobile: t.union([t.undefined, t.string]),
  readMore: t.union([t.undefined, t.null, t.array(ReadMoreData)])
});

export type OutStationOneWayTemplateData = t.TypeOf<
  typeof OutStationOneWayTemplateData
>;

export const CityWithRouteUrls = t.type({
  cityName: t.string,
  cityUrl: t.string,
  routeUrlsList: t.array(RouteInfo)
});

export const PopularCitiesWithRoutes = t.array(CityWithRouteUrls);

export const OutStationOneWayDataChecker = t.type({
  pushToCache: t.boolean,
  cacheKey: t.string,
  status: t.string,
  footerData: t.string,
  popularCitiesWithRoutes: PopularCitiesWithRoutes,
  templateData: OutStationOneWayTemplateData,
  cabTypesAvailableForRent: CabTypesAvailableForRent,
  hrPackages: t.union([t.array(t.string), t.undefined]),
  assistedFormOpenDelay: t.number,
  showTripAssistantButton: t.boolean,
  showTripAssistantButtonForDweb: t.boolean,
  showWhatsappWidget: t.boolean,
  whatsappWidgetDeeplink: t.string,
  customerCareNumber: t.string,
  assistantWidgetText: t.string,
  showWhatsAppForAssistedForm: t.boolean,
  showCallUsWidget: t.boolean,
  showCallUsForAssistedForm: t.boolean,
  inboundCallText: t.union([t.string, t.undefined]),
  inboundCallNumber: t.union([t.string, t.undefined]),
  showInboundCallNumberInDesktop: t.boolean,
  showCallusModalMweb: t.boolean,
  callusModalOpenDelay: t.number,
  showInboundNumberOnAssistedForm: t.boolean
});

export type OutStationOneWayPageData = t.TypeOf<
  typeof OutStationOneWayDataChecker
>;
